import devProperties from "./devProperties";
import uatProperties from "./uatProperties";
import prodProperties from "./prodProperties";

const profileKey =
  (process.env.REACT_APP_PROFILE || process.env.NODE_ENV || "development").toLowerCase();

const profileMap = {
  development: devProperties,
  dev: devProperties,
  uat: uatProperties,
  production: prodProperties,
  prod: prodProperties,
};

// Use profile-based selection, fallback to uat for UAT branch, prod for production
const envProperties = profileMap[profileKey] || uatProperties;

// Log the selected profile for debugging (only in development)
if (process.env.NODE_ENV === "development") {
  console.log(`[envProperties] Selected profile: ${profileKey}, using: ${envProperties.profile}`);
}

export default envProperties;

